exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-2c2399b2] {\n  position: relative;\n  display: inline-block;\n}\n\n/* Tooltip text */\n.tooltip .tooltiptext[data-v-2c2399b2] {\n  visibility: hidden;\n  width: 250px;\n  background: #FAF8FF;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  top: -80px;\n  right: -105%;\n  /* Position the tooltip text - see examples below! */\n  position: absolute;\n  z-index: 1;\n  z-index: 4100;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltiptext[data-v-2c2399b2] {\n  visibility: visible;\n}\n", ""]);

// exports
